import React, { useState } from "react";
import Icon from "components/AppIcon";


// Colombian NIT verification digit algorithm
export function calcVerificationDigit(nit) {
  const cleaned = String(nit)?.replace(/\D/g, "");
  if (!cleaned || cleaned?.length < 1) return null;
  const weights = [3, 7, 13, 17, 19, 23, 29, 37, 41, 43, 47, 53, 59, 67, 71];
  let sum = 0;
  const digits = cleaned?.split("")?.reverse();
  for (let i = 0; i < digits?.length; i++) {
    sum += parseInt(digits?.[i]) * weights?.[i];
  }
  const remainder = sum % 11;
  if (remainder === 0) return 0;
  if (remainder === 1) return 1;
  return 11 - remainder;
}

export function validateNit(nit) {
  const cleaned = String(nit)?.replace(/\D/g, "");
  if (!cleaned) return { valid: false, message: "El NIT es requerido" };
  if (cleaned?.length < 8 || cleaned?.length > 10) return { valid: false, message: "El NIT debe tener entre 8 y 10 dígitos" };
  return { valid: true, message: "" };
}

const NitInput = ({ value, verificationDigit, onChange, onVerificationDigitChange, error }) => {
  const [focused, setFocused] = useState(false);
  const validation = value ? validateNit(value) : null;
  const calculatedDigit = value && validateNit(value)?.valid ? calcVerificationDigit(value) : null;
  const digitMatch = verificationDigit !== "" && calculatedDigit !== null
    ? parseInt(verificationDigit) === calculatedDigit
    : null;

  return (
    <div>
      <label className="block text-sm font-medium mb-1" style={{ fontFamily: "var(--font-caption)", color: "var(--color-foreground)" }}>
        NIT de la Empresa <span style={{ color: "var(--color-error)" }}>*</span>
      </label>
      <div className="flex gap-2 items-start">
        <div className="flex-1 relative">
          <input
            type="text"
            value={value}
            onChange={(e) => onChange(e?.target?.value?.replace(/\D/g, "")?.slice(0, 10))}
            onFocus={() => setFocused(true)}
            onBlur={() => setFocused(false)}
            placeholder="Ej: 900123456"
            maxLength={10}
            className="w-full px-3 py-2 pr-9 rounded-md text-sm border transition-base"
            style={{
              fontFamily: "var(--font-data)",
              background: "var(--color-card)",
              color: "var(--color-foreground)",
              borderColor: error ? "var(--color-error)" : focused ? "var(--color-primary)" : "var(--color-border)",
              outline: "none",
              boxShadow: focused ? "0 0 0 2px var(--color-ring)20" : "none",
            }}
          />
          {value && validation && (
            <span className="absolute right-2 top-1/2 -translate-y-1/2">
              {validation?.valid
                ? <Icon name="CheckCircle" size={16} color="var(--color-success)" />
                : <Icon name="XCircle" size={16} color="var(--color-error)" />}
            </span>
          )}
        </div>
        <div className="flex items-center gap-1">
          <span className="text-lg font-bold" style={{ color: "var(--color-muted-foreground)" }}>-</span>
          <div className="relative">
            <input
              type="text"
              value={verificationDigit}
              onChange={(e) => onVerificationDigitChange(e?.target?.value?.replace(/\D/g, "")?.slice(0, 1))}
              placeholder="DV"
              maxLength={1}
              className="w-14 px-2 py-2 rounded-md text-sm border text-center transition-base"
              style={{
                fontFamily: "var(--font-data)",
                background: "var(--color-card)",
                color: "var(--color-foreground)",
                borderColor: digitMatch === false ? "var(--color-error)" : digitMatch === true ? "var(--color-success)" : "var(--color-border)",
                outline: "none",
              }}
            />
          </div>
        </div>
      </div>
      {calculatedDigit !== null && verificationDigit !== "" && (
        <p className="text-xs mt-1" style={{ fontFamily: "var(--font-caption)", color: digitMatch ? "var(--color-success)" : "var(--color-error)" }}>
          {digitMatch
            ? <span className="flex items-center gap-1"><Icon name="CheckCircle" size={12} color="var(--color-success)" /> Dígito de verificación correcto</span>
            : <span className="flex items-center gap-1"><Icon name="AlertCircle" size={12} color="var(--color-error)" /> El dígito calculado es: {calculatedDigit}</span>}
        </p>
      )}
      {calculatedDigit !== null && verificationDigit === "" && (
        <p className="text-xs mt-1" style={{ fontFamily: "var(--font-caption)", color: "var(--color-muted-foreground)" }}>
          Dígito de verificación calculado: <strong style={{ fontFamily: "var(--font-data)" }}>{calculatedDigit}</strong>
        </p>
      )}
      {error && <p className="text-xs mt-1" style={{ color: "var(--color-error)", fontFamily: "var(--font-caption)" }}>{error}</p>}
      <p className="text-xs mt-1" style={{ color: "var(--color-muted-foreground)", fontFamily: "var(--font-caption)" }}>
        Formato: 8-10 dígitos sin puntos ni guiones. El dígito de verificación (DV) se calcula automáticamente.
      </p>
    </div>
  );
};

export default NitInput;